import { render, staticRenderFns } from "./FacebookPageAdPosts.vue?vue&type=template&id=290232ee"
import script from "./FacebookPageAdPosts.vue?vue&type=script&lang=js"
export * from "./FacebookPageAdPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports